import React from "react";
import { CircularProgress } from "@mui/material";

const CommonCircularProgress = (props) => {
  return <CircularProgress sx={{ color: "#ff8000", margin: "0 5px" }} size={30} {...props} />;
};

export default CommonCircularProgress;
